import { Component, OnInit } from '@angular/core';  
@Component({
  selector: 'iswm-cmp',
  templateUrl: './iswm.component.html', 
})
export class IswmComponent implements OnInit {
   
  constructor() { }

  ngOnInit(){  
  }
}



// WEBPACK FOOTER //
// ./src/app/iswmMgt/iswm.component.ts